module.exports = __webpack_public_path__ + "img/87.1ed41f4c.jpg";